import Multiselect from 'vue-multiselect'

export default {
    install(Vue) {
        Vue.component('multiselect', Multiselect)      
    }
};
